import { render } from "./ExpressQuestionPage.vue?vue&type=template&id=61ec8318"
import script from "./ExpressQuestionPage.vue?vue&type=script&lang=js"
export * from "./ExpressQuestionPage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__